MicroModal.init( {
	disableScroll: true, // [6]
	disableFocus: true, // [7]
	awaitOpenAnimation: true, // [8]
	awaitCloseAnimation: true, // [9]
	debugMode: false // [10]
} );
